import React from "react";
import curve from "../../assets/icons/curvyline.svg"; // Example icon 1
import dot from "../../assets/icons/dot.svg"; // Example icon 2
import project from "../../assets/icons/projects.svg";
import health from "../../assets/icons/health.svg";
import community from "../../assets/icons/commnity.svg";

const TopSection = () => {
	return (
		<section className='max-w-[1440px] w-[90%] mx-auto lg:pt-40 pt-20 pb-16 relative space-y-10'>
			{/* Title and Description */}

			<h1 className='lg:text-[72px]/[79px] text-[28px]/[32px] font-semibold text-[#11112D] mb-4 text-center'>
				About Us
			</h1>

			{/* Paragraph Section */}
			<p className='max-w-[994px] w-full text-center mx-auto lg:text-2xl/10 text-lg/6 leading-10 text-[#11112d] font-normal mb-8'>
				SynergyCare Foundation is a nonprofit organization dedicated to bridging
				the gap between underserved populations and essential healthcare
				services. We believe everyone deserves access to timely and affordable
				healthcare, regardless of their socioeconomic status. Beyond healthcare,
				we also connect communities to critical social services, temporary
				housing, and non-emergency medical transportation.
			</p>

			{/* Dot Icon */}

			<div className='flex justify-evenly mt-8'>
				<div
					className='text-center bg-cover bg-center bg-no-repeat lg:p-4 p-1 md:w-40 w-20  rounded-full flex flex-col justify-center items-center lg:tracking-[-2px] tracking-[-1px]'
					style={{ backgroundImage: `url(${project})` }}>
					<p className='font-medium text-2xl/7 md:text-[72px]/[73px] text-black'>
						10k+
					</p>
					<p className='md:text-2xl/8 text-xs/3  font-normal text-[#4A4A4A]'>
						Patients
						<br /> Referred
					</p>
				</div>

				<div
					className='text-center bg-cover bg-center bg-no-repeat lg:p-4 p-1 md:w-40 w-20  rounded-full flex flex-col justify-center items-center lg:tracking-[-2px] tracking-[-1px]'
					style={{ backgroundImage: `url(${health})` }}>
					<p className='font-medium text-2xl/7 md:text-[72px]/[73px] text-black'>
						50+
					</p>
					<p className='md:text-2xl/8 text-xs/3  font-normal text-[#4A4A4A]'>
						Healthcare
						<br /> Partners
					</p>
				</div>

				<div
					className='text-center bg-cover bg-center bg-no-repeat lg:p-4 p-1 md:w-40 w-20  rounded-full flex flex-col justify-center items-center lg:tracking-[-2px] tracking-[-1px]'
					style={{ backgroundImage: `url(${community})` }}>
					<p className='font-medium text-2xl/7 md:text-[72px]/[73px] text-black'>
						20+
					</p>
					<p className='md:text-2xl/8 text-xs/3  font-normal text-[#4A4A4A]'>
						Communities <br /> Served
					</p>
				</div>
			</div>

			<img
				src={curve}
				alt='Curve Decoration'
				className='absolute lg:top-[-20px] lg:right-0 top-[-20px] right-[40%] w-[90px] lg:w-[208px]'
			/>
			<img
				src={dot}
				alt='Icon 2'
				className='absolute left-0 bottom-0 hidden lg:block'
			/>
		</section>
	);
};

export default TopSection;
